export default "__VITE_PUBLIC_ASSET__c60277ba__"